import { render } from "./Tags.vue?vue&type=template&id=697c760a"
import script from "./Tags.vue?vue&type=script&lang=js"
export * from "./Tags.vue?vue&type=script&lang=js"
script.render = render

export default script